import { render, staticRenderFns } from "./startConfig.vue?vue&type=template&id=e743ac8a&scoped=true&"
import script from "./startConfig.vue?vue&type=script&lang=js&"
export * from "./startConfig.vue?vue&type=script&lang=js&"
import style0 from "./startConfig.vue?vue&type=style&index=0&id=e743ac8a&scoped=true&lang=css&"
import style1 from "./startConfig.vue?vue&type=style&index=1&id=e743ac8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e743ac8a",
  null
  
)

export default component.exports